import { cn } from '@shared/components/shadcn';
import Image from 'next/image';
import Link, { type LinkProps } from 'next/link';

type HomeGameCardProps = Readonly<
  LinkProps & {
    title: string;
    subtitle: string;
    scheduleText: string;
    href: string;
    backgroundClassName: string;
    foregroundClassName: string;
    imageSrc?: string;
    testId?: string;
    headingId?: string;
    className?: string;
  }
>;

function HomeGameCard({
  title,
  subtitle,
  scheduleText,
  href,
  backgroundClassName,
  foregroundClassName,
  imageSrc,
  testId = 'home-game-card',
  headingId = 'home-game-card-heading',
  className,
  ...props
}: HomeGameCardProps) {
  return (
    <Link href={href} data-testid={testId} className={cn(backgroundClassName, 'flex h-full gap-3 rounded-2xl p-4 select-none', className)} {...props}>
      <div className={cn('flex min-w-0 flex-1 flex-col', foregroundClassName)}>
        <h3 id={headingId} className="paragraph-l-strong">
          {title}
        </h3>
        <span className="display-s-strong flex-1">{subtitle}</span>
        <p className="paragraph-s-strong mt-1">{scheduleText}</p>
      </div>
      {imageSrc ? <Image src={imageSrc} alt="" width={64} height={64} className="pointer-events-none h-15 w-15 shrink-0 self-end -mr-2 -mb-2 object-contain" aria-hidden /> : null}
    </Link>
  );
}

export { HomeGameCard };
export type { HomeGameCardProps };
